import { ContactsSelectFilter } from '../types/contactsSelectFilter'

export const getDefaultContactsFilters = (): ContactsSelectFilter => ({
  isArchived: false,
})
